<RepairDetailSearch headerTextCD="Central Delivery  Repair/Event" detailsType="Central Delivery" AddUrl="/Concentrates/Repairs/RepairDetail">
